const numberToCurrencyString = (amount: number, currencyCode: string) => {
	return amount.toLocaleString('en-US', {
		style: 'currency',
		currency: currencyCode,
	});
};

export default numberToCurrencyString;
